import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import SingleSelect from 'components/common/SingleSelect';
import selectCustomStyles from 'sites/common/SelectCustomStyles';

export const ProjectStatusFilter = ({ setFiltersAndSort, filtersAndSort }) => {
  const statusOptions = [
    { value: 'Todos', label: 'Todos' },
    { value: 'En pozo', label: 'En pozo' },
    { value: 'En construcción', label: 'En construcción' },
    { value: 'Terminado', label: 'Terminado' }
  ];

  const handleChange = selectedOption => {
    setFiltersAndSort(state => ({
      ...state,
      project_status:
        selectedOption.value === 'Todos' ? '' : selectedOption.value
    }));
  };
  return (
    <Form.Group>
      <Form.Label>Estado del emprendimiento</Form.Label>

      <SingleSelect
        onChange={handleChange}
        options={statusOptions}
        isSearchable={false}
        defaultValue={statusOptions[0]}
        value={statusOptions.find(
          option => option.value === filtersAndSort.project_status
        )}
        styles={selectCustomStyles}
      />
    </Form.Group>
  );
};
ProjectStatusFilter.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired
};
